export default "__VITE_ASSET__DqVsaNNP__"